import { Popover } from "frost-ui-react";
import React, { useRef, useState } from "react";
import styled from "styled-components";
import useOutsideAlerter from "../../../hooks/useOutsideAlerter";
import AppIcon from "../../Core/AppIcon/AppIcon";

const arrowOffset = "20px";

interface HelpTooltipProps {
	children: React.ReactNode;
	margin?: string;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ children, margin }) => {
	const [open, setOpen] = useState(false);
	const wrapperRef = useRef<HTMLDivElement>(null);

	useOutsideAlerter(wrapperRef, () => setOpen(false));

	return (
		<StyledHelpTooltip ref={wrapperRef} margin={margin}>
			<AppIcon icon="help" size="13px" onClick={() => setOpen(!open)} />
			{open && (
				<div className="popover-ctn">
					<Popover pointTo="top" styles={{ offset: arrowOffset, width: 170 }}>
						{children}
					</Popover>
				</div>
			)}
		</StyledHelpTooltip>
	);
};

export default HelpTooltip;

const StyledHelpTooltip = styled.div<{ margin?: string }>`
	position: relative;
	cursor: pointer;
	margin: ${(props) => props.margin || "0"};

	.popover-ctn {
		position: absolute;
		left: -${arrowOffset};
		top: 27px;
		font-size: 0.8rem;
		z-index: 2;
	}
`;
